import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export const useEstudantesAtivos = (instituicaoId) => {
  const [data, setData] = useState({
    estudantes: [],
    total: 0,
    tipoInstituicao: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEstudantes = useCallback(async () => {
    if (!instituicaoId) return;

    try {
      setLoading(true);
      const response = await api.get(`/instituicoes/${instituicaoId}/estudantes-ativos`);
      setData({
        estudantes: response.data.estudantes,
        total: response.data.total,
        tipoInstituicao: response.data.tipoInstituicao
      });
      setError(null);
    } catch (err) {
      console.error('Erro ao buscar estudantes ativos:', err);
      setError(err.message || 'Erro ao carregar estudantes ativos');
      setData({ estudantes: [], total: 0, tipoInstituicao: null });
    } finally {
      setLoading(false);
    }
  }, [instituicaoId]);

  useEffect(() => {
    fetchEstudantes();
  }, [fetchEstudantes]);

  return {
    estudantes: data.estudantes,
    total: data.total,
    tipoInstituicao: data.tipoInstituicao,
    loading,
    error,
    refetch: fetchEstudantes
  };
};

export default useEstudantesAtivos;